import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2450b6be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["name", "value", "checked"]
const _hoisted_3 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["name", "value", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.object?.Stats[_ctx.statTypeEnum.Design].Data)
  }, [
    (_ctx.returnIfExists(_ctx.statTypeEnum.ItemList) && !_ctx.returnIfExists(_ctx.statTypeEnum.Name))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.object.Stats[_ctx.statTypeEnum.ItemList].Data), (item, key, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${ key }-${ index }`
            }, [
              _createElementVNode("input", {
                class: "form-check-input mt-0",
                name: _ctx.object.Stats[_ctx.statTypeEnum.Tag].Data,
                value: item.id,
                type: "radio",
                checked: _ctx.object.Stats[_ctx.statTypeEnum.Value].Data===item.id,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.regionType.RegionTypes[_ctx.object.Region].ObjectTypes[_ctx.object.ObjectEnum].ChooseSubType(_ctx.object as ObjectTemplate, $event.target.value)))
              }, null, 40, _hoisted_2),
              _createElementVNode("label", _hoisted_3, _toDisplayString(item.name), 1)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("input", {
            class: "form-check-input",
            name: _ctx.object.Stats[_ctx.statTypeEnum.Name].Data,
            value: _ctx.object.Stats[_ctx.statTypeEnum.ItemList].Data,
            type: "radio",
            checked: _ctx.object.Stats[_ctx.statTypeEnum.ItemList].Data===_ctx.object.Stats[_ctx.statTypeEnum.Value].Data,
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.regionType.RegionTypes[_ctx.object.Region].ObjectTypes[_ctx.object.ObjectEnum].ChooseSubType(_ctx.object as ObjectTemplate, $event.target.value)))
          }, null, 40, _hoisted_5)
        ]))
  ], 2))
}